import { PrimaryButton } from '@/components';
import { Stack } from '@mui/material';

export const TicketsOptionHead = () => {
  return (
    <Stack direction="row" justifyContent="space-between" pl={2} pb={3}>
      Tickets
      <PrimaryButton>Create Ticket</PrimaryButton>
    </Stack>
  );
};
